import React from 'react'
import Icon from "../Icon/Icon";

export const ButtonHeader = ({ icon, onClick, style, text, iconStyle, type, title }) => {

  return (
    <button onClick={onClick} style={style} type={type} title={title}>
      { text }
      { icon ? <Icon icon={icon} style={iconStyle} /> : null }
    </button>
  )
}



// WEBPACK FOOTER //
// ./src/component/Button/ButtonHeader.js